// extracted by mini-css-extract-plugin
module.exports = {"products__grid":"Products_products__grid__35Xho","loader":"Products_loader__23TAR"};